import $ from 'jquery'
import LmwSlidersManager from 'slider/js/slider'

$(function() {
   const sliders = new LmwSlidersManager();
});